/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust_BadgeInputs */

const en_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for Europe`)
};

const de_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuer Europa gebaut`)
};

const fr_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conçu pour l'Europe`)
};

const es_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho para Europa`)
};

const it_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensato per l'Europa`)
};

const nl_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebouwd voor Europa`)
};

const pl_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stworzone dla Europy`)
};

const fi_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakennettu Eurooppaan`)
};

const da_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget til Europa`)
};

const sv_landing_trust_badge = /** @type {(inputs: Landing_Trust_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggt för Europa`)
};

/**
* | output |
* | --- |
* | "Built for Europe" |
*
* @param {Landing_Trust_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_trust_badge = /** @type {((inputs?: Landing_Trust_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_trust_badge(inputs)
	if (locale === "fr") return fr_landing_trust_badge(inputs)
	if (locale === "es") return es_landing_trust_badge(inputs)
	if (locale === "it") return it_landing_trust_badge(inputs)
	if (locale === "nl") return nl_landing_trust_badge(inputs)
	if (locale === "pl") return pl_landing_trust_badge(inputs)
	if (locale === "fi") return fi_landing_trust_badge(inputs)
	if (locale === "da") return da_landing_trust_badge(inputs)
	if (locale === "sv") return sv_landing_trust_badge(inputs)
	return en_landing_trust_badge(inputs)
});